<script lang="ts">
  import RepositoryFactory, { DATA_CHARGE } from '../../repositories/RepositoryFactory';
  import { loginUser } from '../../components/auth/LoginUser';
  import Loading from '../loader.svelte';
  import { getContext } from 'svelte';

  const { close }: any = getContext('simple-modal');
  let promise = getApi();

  async function getApi() {
    const dataChargeRepository = RepositoryFactory[DATA_CHARGE];
    return await dataChargeRepository
      .getDataChargeHistory({})
      .then((res) => {
        return res;
      })
      .catch((error) => {
        if (error.response.status === 403) {
          alert('セッションが切れました。再度ログインしてください。');
          loginUser.logout();
          location.reload();
        }
        throw new Error();
      });
  }
</script>

<div class="h-auto p-8 bg-white w-full m-auto">
  <div class="mb-5 screen-title">
    <span class="text-gray-700 text-2xl font-bold">データチャージ履歴</span>
  </div>

  {#await promise}
    <Loading />
  {:then dataChargeHistoryList}
    <div class="shadow rounded-lg bg-gray-50 p-8 border-t-4 border-green-400">
      <div class="flex flex-col divide-y divide-gray-300">
        <div class="flex-auto flex flex-col">
          <div class="flex-auto">
            <div class="overflow-x-auto">
              <div class="align-middle inline-block min-w-full">
                <div class="overflow-auto">
                  <table class="min-w-full divide-y divide-gray-200 rounded-lg border-collapse">
                    <thead class="bg-gray-100">
                      <tr>
                        <th>実施日</th>
                        <th>チャージ対象</th>
                      </tr>
                    </thead>
                    {#await promise}
                      <Loading />
                    {:then dataChargeHistoryList}
                      <tbody class="divide-y divide-gray-200">
                        {#each dataChargeHistoryList as dataCharge}
                          <tr class="group">
                            <td>{dataCharge.chargeRequestDate}</td>
                            <td>{dataCharge.chargeCapacity}</td>
                          </tr>
                        {/each}
                      </tbody>
                    {/await}
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  {/await}
</div>

<style lang="postcss">
  thead tr th {
    @apply border border-gray-800 px-4 py-3 text-center text-sm text-gray-700 whitespace-nowrap leading-4;
  }
  tbody tr td {
    @apply border border-gray-800 px-4 py-3 text-center text-sm text-gray-700 whitespace-nowrap leading-4;
  }
</style>
